// import geopi from 'geoip-lite'
// https://es.wikipedia.org/wiki/ISO_3166-1
// https://es.wikipedia.org/wiki/ISO_3166-2
// https://es.wikipedia.org/wiki/ISO_3166-3
// https://restcountries.eu/
// https://es.wikipedia.org/wiki/ISO_639-1 || estandar idiomas
// https://docs.google.com/spreadsheets/d/1KOAVMF339uoca3QkLTLfmS1T94K4kNZ51s_Ycekfq48/edit#gid=0 || recursos
// params: no cambian en ejecución. opctions: cambian en ejecucion

// eslint-disable-next-line
import Vue from "vue";
// import infoo from "../plugins/infoo";

const helpers = {
  namespaced: true,
  state: {
    clientLocation: {
      status: "",
      country: "",
      countryCode: "",
      region: "",
      regionName: "",
      city: "",
      zip: "",
      lat: 0,
      lon: 0,
      timezone: "",
      isp: "",
      org: "",
      as: "",
      query: ""
    },
    paises: {
      es: [],
      en: [],
      pt: []
    },
    deptos: {},
    flags: {
      br: "bra",
      co: "col",
      pa: "pan",
      us: "usa"
    },
    isoLangs: {
      es: [],
      pt: []
    }
  },
  getters: {
    clientInfo() {
      return {
        nan: navigator.appName, // navigatorAppName
        nac: navigator.appCodeName, // navigatorAppCodeName
        nav: navigator.appVersion, // navigatorappVersion
        npl: navigator.platform, // navigatorPlatform
        npr: navigator.product, // navigatorProduct
        nua: navigator.userAgent, // navigatorUserAgent
        nla: navigator.language, // navigatorLanguage
        nol: navigator.onLine, // navigatorOnLine
        nje: navigator.javaEnabled(), // navigatorJavaEnabled
        wih: window.innerHeight, // wihndowInnerHeight
        wiw: window.innerWidth // windowInnerWidth
      };
    },
    clientLocation(state) {
      return state.clientLocation;
    },
    deptos(state) {
      return state.deptos;
    },
    paises(state, getters, rootState, rootGetters) {
      let userConfig = rootGetters["user/config"];
      return state.paises[userConfig.mdd.lng];
    },
    flags(state) {
      return state.flags;
    },
    isoLangs(state, getters, rootState, rootGetters) {
      let userConfig = rootGetters["user/config"];
      return state.isoLangs[userConfig.mdd.lng];
    }
  },
  mutations: {
    clientLocation(state, location) {
      Vue.set(state, "clientLocation", location);
      this.$local.set("app/helpers/clientLocation", location);
    },
    loadPaises(state, payload) {
      if (!payload.lng) return;

      let lng = payload.lng || "es";
      let paises = payload.data ? payload.data[lng] : [];

      Vue.set(state.paises, lng, paises);
    },
    loadDeptos(state, payload) {
      if (!payload.codPais) return;

      let codPais = payload.codPais;
      if (!state.deptos[codPais]) Vue.set(state.deptos, codPais, []);

      Vue.set(state.deptos, codPais, payload.data[codPais.toUpperCase()]);
    }
  },
  actions: {
    getPaises({ commit }, lng) {
      lng = lng || "es";

      fetch("/static/json/paises.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          commit("loadPaises", { lng: lng, data: json });
        })
        .catch(() => {
          // TODO: reportar error en la app
        });
    },
    getDeptos({ commit }, codPais) {
      if (!codPais) return;

      fetch("/static/json/deptos.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          commit("loadDeptos", { codPais: codPais, data: json });
        })
        .catch(() => {
          // TODO: reportar error en la app
        });
    },
    getClientLocation({ commit }) {
      return new Promise(resolve => {
        let location = this.$local.get("app/helpers/clientLocation");

        if (location) {
          commit("clientLocation", location);
          resolve();
        } else {
          fetch("http://ip-api.com/json")
            .then(response => {
              return response.json();
            })
            .then(json => {
              commit("clientLocation", json);
              resolve(json);
            })
            .catch(() => {
              resolve();
            });
        }
      });
    },
    updateClientLocation({ commit }) {
      fetch("http://ip-api.com/json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          commit("clientLocation", json);
          return json;
        })
        .catch(() => {
          return null;
        });
    }
  }
};

export default helpers;
